import parseNavigation from './parseNavigation';

/** Menú del rol plan colectivo: `tipo id | título | ícono | url`, anidado por tabulación. */
const collectiveplanNavigation = parseNavigation(`
group collectiveplan-certificates | Certificados | account_tree
	item collectiveplan-certificate-avaibles | Certificados disponibles | check_circle_outline | /certificates/collectiveplan/avaibles
	item collectiveplan-certificate-nominees | Certificados nominados | person_pin | /certificates/collectiveplan/nominees
	item plan-circularity-available | Certificados de circularidad disponibles | recycling | /circularity/available
	item plan-circularity-nominations | Certificados de circularidad nominados | how_to_reg | /circularity/consult/nominations
group plan-consults | Consultas | account_tree
	item plan-received-transfer-info | Certificados recibidos | move_to_inbox | /plan/consult/received-transfer-info
	item plan-transfer | Certificados disponibles | check_circle_outline | /plan/consult/transfer
	item plan-send-transfer-info | Certificados transferidos | send | /plan/consult/send-transfer-info
	item plan-circularity-received | Certificados de circularidad recibidos | move_to_inbox | /circularity/consult/received-transfer
	item plan-circularity-sent | Certificados de circularidad transferidos | send | /circularity/consult/sent-transfer
`);

export default collectiveplanNavigation;
